import React from "react";
import PermissionEnum from "../../controllers/PermissionEnum";
import SoilTab from "./SoilTab";
import EntriesBase from "../BaseFarmersAndSoil/EntriesBase";

const SoilEntries: React.FC = () => {
    return <EntriesBase TabComponent={SoilTab} 
                        permission={PermissionEnum.SoilEntries}/>
}

export default SoilEntries;